import * as React from 'react';
import { Menu, Container, Image, Icon, Sidebar, Segment, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import MobileSidebarMenu from './MobileSidebarMenu';

interface Props {
    fixed?: boolean;
    activeMenu: string;
}

interface State {
    sidebarOpened?: boolean;
}

export class MobileMenu extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            sidebarOpened: false
        }
    }

    toggleSidebarMenu = () => this.setState({ sidebarOpened: !this.state.sidebarOpened })

    render() {
        const { fixed, activeMenu } = this.props;
        const { sidebarOpened } = this.state;
        return <div>
            <Menu
                fixed={fixed ? 'top' : undefined}
                inverted={!fixed}
                pointing={!fixed}
                secondary={!fixed}
                borderless
                style={{ border: fixed ? undefined : "none" }}
                size='large'
            >
                <Container>
                    <Menu.Item as={Link} to="/"
                        style={{ paddingBottom: fixed ? 0 : 4, paddingTop: 0 }}>
                        <Image
                            src={fixed ? "/images/logo-medium-light.png" : "/images/logo-medium-dark.png"}
                            height={35}
                        />
                    </Menu.Item>

                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Button primary as={Link} to="/sign-up" inverted={!fixed}>Sign Up</Button>
                        </Menu.Item>

                        <Menu.Item onClick={this.toggleSidebarMenu}>
                            <Icon name='sidebar' />
                        </Menu.Item>
                    </Menu.Menu>

                </Container>
            </Menu>
            <div style={{ position: "fixed", zIndex: 10000, top: 0, left: 0, width: "100%", height: "100vh", pointerEvents: sidebarOpened ? "auto" : "none" }}>
                <Sidebar.Pushable as={Segment} style={{ background: sidebarOpened ? "rgba(0,0,0,0.2)" : "none", textAlign: "left" }}>
                    <MobileSidebarMenu activeMenu={activeMenu} sidebarOpen={sidebarOpened} />
                    <Sidebar.Pusher onClick={this.toggleSidebarMenu} />
                </Sidebar.Pushable>
            </div>
        </div>
    }
}


export default MobileMenu;


// WEBPACK FOOTER //
// ./src/common/MobileMenu.tsx